<template>
    <v-container id="home" class="fill-height" >
        <v-snackbar
        v-model="snackbarVerify"
        :vertical="vertical"
        color="red"
        :timeout="10000" top
            >
        {{ text }}
        <v-btn
            color="white"
            text
            @click="snackbarVerify = false"
        >
            Close
        </v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar" :timeout="10000" top :color="color">
            <span>{{message}}</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-dialog v-model="dialog" max-width="500" persistent>
            <v-card class="pa-7" color="#e0e0e0" >
                <v-card-text class="text-center">
                    <v-avatar color="white" size="90" class="mt-n3">
                        <v-icon color="green" x-large>mdi-check-bold</v-icon>
                    </v-avatar>
                </v-card-text>
                <v-card-text class="text-center black--text">Your offer has been cancelled</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn to="/orders">Back</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog1" max-width="500" persistent>
            <v-card class="pa-7" color="#e0e0e0" >
                <v-card-text class="text-center">
                    <v-avatar color="white" size="90" class="mt-n3">
                        <v-icon color="green" x-large>mdi-check-bold</v-icon>
                    </v-avatar>
                </v-card-text>
                <v-card-text class="text-center black--text">Your Order has been confirmed</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog1=false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12" sm="6" md="8">
                <v-card class="pa-2 mt-3">
                    <v-row style="background-color:white" >
                        <v-col cols="12" sm="12" md="4">        
                            <!-- <v-img src="/serverdown.png"></v-img> -->
                            <v-carousel  hide-delimiters height="150" show-arrows-on-hover cycle>
                                <v-carousel-item v-for="item in orderItems" :key="item.id" :src="item.imgUrl" reverse-transition="fade-transition" transition="fade-transition"  width="200" contain></v-carousel-item>
                            </v-carousel>
                        </v-col>
                        <v-col cols="12" sm="12" md="8" class="mx-auto">
                            <v-card-text class="pb-0 mt-n3"> 
                                <v-row v-for="item in orderItems" :key="item.id"  class="mx-auto mt-n3" no-gutters>
                                    <v-col cols="12" md="10" sm="10">
                                        <v-card-text class="pa-1 black--text">{{item.itemName}} .</v-card-text> 
                                    </v-col >
                                    <v-col cols="12" md="2" sm="2">
                                        <v-card-text class="text-right pa-1 black--text font-weight-bold">$ {{item.price.toFixed(2)}}</v-card-text>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            
                            <v-row no-gutters="">
                                <v-col>
                                    <v-subheader>ORIGINAL</v-subheader>
                                    <v-card-text class="font-weight-black pt-0 mt-n1">${{parseFloat(order.originalTotalPrice).toFixed(2)}}</v-card-text>
                                </v-col>
                                <v-col>
                                    <v-subheader>x{{orderItems.length }}</v-subheader>
                                </v-col>
                            </v-row>
                            
                        </v-col>
                    </v-row>
                </v-card>
                <v-card class="px-2 mt-2">
                    <v-row>
                        <v-col>
                            <v-subheader>Total Cost</v-subheader>
                            <v-card-text class="font-weight-black mt-0 pt-0" v-if="order.earnerId===userId">${{parseFloat(order.originalTotalPrice).toFixed(2)}}</v-card-text>
                            <v-card-text class="font-weight-black mt-0 pt-0" v-if="order.shopperId===userId">${{parseFloat(order.totalPay).toFixed(2)}}</v-card-text>
                        </v-col>
                        <v-col>
                            <v-subheader>BTC TOTAL</v-subheader>
                            <v-card-text class="font-weight-bold mt-0 pt-0 green--text" v-if="order.shopperId===userId">{{parseFloat(order.btcPrice).toFixed(8)}} BTC</v-card-text>
                            <v-card-text class="font-weight-bold mt-0 pt-0 green--text" v-if="order.earnerId===userId">{{parseFloat(order.originalbtcPrice).toFixed(8)}} BTC</v-card-text>
                        </v-col>
                        <v-col>
                            <v-subheader>EFFECTIVE RATE</v-subheader>
                            <v-card-text class="font-weight-black mt-0 pt-0">${{parseFloat(BtcRate).toFixed(8)}}/BTC</v-card-text>
                        </v-col>
                    </v-row>
                </v-card>

                <v-card flat class="mt-12 pa-3">
                    <v-card-title class="font-weight-black">
                        Activity Log
                    </v-card-title>
                    <v-row>
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header class="grey--black" @click="updateRead()">
                                    <div v-if="messageCount<1">Notifications <v-icon small color="blue">mdi-bell</v-icon></div>
                                    <div v-if="messageCount>0">Notifications <v-icon small color="red">mdi-bell</v-icon></div>
                                    <v-spacer></v-spacer>
                                    <div v-if="messageCount>0"><i class="black--text">you have <v-btn icon x-small="" style="border: 2px red solid" class="black--text font-weight-bold">{{messageCount}}</v-btn> unread <span v-if="messageCount>1">messages</span><span v-if="messageCount===1">message</span></i></div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="">
                                    <v-card
                                        class=""
                                        >
                                        <v-card
                                            dark
                                            flat
                                            >
                                        
                                            <v-card-title class="pa-2" >
                                                <v-spacer></v-spacer>
                                                <v-icon>mdi-human-greeting</v-icon>
                                                <h3 class="title font-weight-light text-center grow">Activities</h3>
                                                <v-spacer></v-spacer>
                                            </v-card-title>
                                        </v-card>
                                        <v-card-text class="py-0">
                                            <v-timeline
                                                align-top
                                                dense
                                            >
                                                <v-timeline-item
                                                    color="#B45C5C"
                                                    small
                                                    v-for="msg in messages" :key="msg.id"
                                                >
                                                    <v-row class="pt-1" >
                                                        <v-col>
                                                        <strong class="green--text" v-if="msg.status!=='Cancelled'">{{msg.status.toUpperCase()}}</strong> 
                                                        <strong class="red--text" v-if="msg.status==='Cancelled'">{{msg.status.toUpperCase()}}</strong> 
                                                        <div class="caption black--text" v-if="msg.messageFrom"><strong>By:</strong> {{msg.username.toUpperCase()}}</div>
                                                        <div class="caption black--text" v-if="!msg.messageFrom"><strong>By:</strong> System Administrator</div>
                                                        <div class="caption black--text text-justify"><strong>Text:</strong> <span>{{msg.text}}</span></div>
                                                        <div class="caption black--text"><strong>Date:</strong> {{msg.messageTime.slice(0, 19).replace('T', ' ')}}</div>
                                                        </v-col>
                                                    </v-row>
                                                </v-timeline-item>   
                                            </v-timeline>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>
                    <v-row v-if="order.status!=='Completed'">
                        <v-col cols="12" md="3" sm="3">
                            <v-img src="/profile_pic.svg" height="60px" contain=""></v-img>

                        </v-col>
                        <v-col cols="12" md="9" sm="9">
                            <v-textarea solo label="Send a message to the shopper" v-model="sendMsg" v-if="userId===order.earnerId"></v-textarea>
                            <v-textarea solo label="Send a message to the earner" v-model="sendMsg" v-if="userId===order.shopperId"></v-textarea>
                        </v-col>
                    </v-row>
                    <v-card-actions class="mt-n10" v-if="order.status!=='Completed'&order.status!=='Pending'">
                        <v-spacer></v-spacer>
                        <v-btn dark color="blue" large v-if="sendMsg!==''" :loading='loading' @click="sendMessage()">SEND</v-btn>
                        <v-btn color="blue" large disabled="true" v-if="sendMsg===''">SEND</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="6">
                <v-card class="black--text mx-auto py-3 px-4" max-width="500px" flat >
                    <v-toolbar>
                        <v-card-text class="text-center font-weight-black" v-if="order.status!=='Pending'">
                            <v-badge class="mx-3 mt-n9" color="green" dot bordered="true"></v-badge> 
                             {{order.status.toUpperCase()}}</v-card-text>
                             <v-card-text class="text-center font-weight-black" v-if="order.status==='Pending'&userId===order.shopperId">
                            <v-badge class="mx-3 mt-n" color="green" dot bordered="true"></v-badge> 
                             WAITING FOR EARNER</v-card-text>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card v-if="order.status==='Completed'">
                        <v-card-text class="text-center grey--text mb-0 pb-0">YOUR RATING</v-card-text>
                        <v-card-text class="text-center grey--text mt-0 pt-0">
                            <v-rating v-model="rate" small color="orange" class="pa-0 ma-0 d-inline" dense :readonly="readonly" @input="rating($event)">
                            </v-rating>
                        </v-card-text>
                    </v-card>
                    
                    <v-divider></v-divider>
                    <v-card >
                        <v-card-text class="text-center">
                            <v-btn color="green" class="mb-3" style="width:100%; border:12px teal solid" dark large v-if="order.shopperId===userId&order.status!=='Pending'&order.status!=='Completed'&order.status!=='Cancelled'&order.status!=='Accepted'" @click="confirmDelivery()" :loading="loading">
                                CONFIRM DELIVERY
                            </v-btn>
                            <v-btn color="green" class="mb-3"  style="width:100%; border:12px teal solid" dark large v-if="order.earnerId===userId">
                                ADD TRACKING #
                            </v-btn>
                            <v-btn color="yellow darken-2"  style="width:100%; border:12px teal solid" dark large>
                                CONTACT SUPPORT
                            </v-btn>
                            <v-btn text  style="width:100%; border:2px teal solid" dark large class="teal--text mt-3" v-if="order.status==='Pending'&userId===order.shopperId" @click="modify()" :loading="loadmodify">
                                MODIFY ORDER
                            </v-btn>
                            <v-btn  text style="width:100%; border:2px teal solid" dark large class="teal--text mt-3" v-if="order.status==='Pending'&userId===order.shopperId" @click="shopperCancelOrder()" :loading="loading">
                                CANCEL ORDER
                            </v-btn>
                            <v-btn color="red" class="mt-3" style="width:100%; border:12px teal solid" dark large @click="cancelTrans=true"  v-if="order.earnerId===userId&(order.status==='Waiting for confirmation'||order.status==='Not shipped'||order.status==='Cancelled')">
                                CANCEL TRANSACTION
                            </v-btn>
                        </v-card-text>

                        <v-card-text class="black--text mb-0 pb-0" v-if="order.status!=='Pending'">ORDER DATE: {{order.orderDate}}</v-card-text>
                        <v-card-text class="black--text mb-0 pb-0" v-if="order.status!=='Pending'">BITSHOPY ORDER #: {{order.bitshopyOrder}}</v-card-text>
                        <v-card-text class="black--text" v-if="order.status!=='Pending'">AMAZON ORDER: {{order.amazonOrder}}</v-card-text>

                        <v-card-text class="text-center mt-3 mb-8" v-if="order.status!=='Pending'&order.status!='Waiting for confirmation'">
                            <a :href="order.orderLink"  target="_blank" style="width:400px"><v-btn large color="blue"  class="heading font-weight-bold" style="width:50%" >
                                TRACK
                            </v-btn></a>
                        </v-card-text>
                    </v-card>
                    <v-divider></v-divider>
                    <v-card>
                        <v-card-text class="text-center">
                            <v-img src="/profile_pic.svg" height="50px" contain=""></v-img>
                            <p class="font-weight-black ma-2">{{user.username}}</p>
                        </v-card-text>
                        <v-card-actions class="pa-1">
                            <v-icon>mdi-compare-horizontal</v-icon><span class="font-weight-bold grey--text">{{user.noOfRatings}}</span>
                            <v-divider
                                class="mx-4"
                                inset
                                vertical
                            ></v-divider>
                           <v-rating v-model="user.ratings" small color="orange" class="pa-0 ma-0 d-inline" readonly dense></v-rating>
                            <v-divider
                                class="mx-4"
                                inset
                                vertical
                            ></v-divider>
                            <span class="grey--text font-weight-bold">LVL {{user.level}}</span>
                        </v-card-actions>
                    </v-card>

                    
                </v-card>
            </v-col>
        </v-row>
  
        <!-- cancel dialog -->
        <v-dialog v-model="cancelTrans" max-width="500px">
            <v-card>
                <v-card-text style="background-color:#E0E0E0" class="text-center pa-10" >
                    <h1 class="black--text">Are you sure you want to cancel?</h1>
                </v-card-text>
               
                <v-card-text class="text-center my-5">
                    <v-select :items="reasons" label="Select Reason" solo v-model="reason"></v-select>
                    <v-textarea solo placeholder="Please provide a detailed description of the issue so we can inform the shopper" v-if="reason==='Other'" v-model="reasonSub"></v-textarea>

                </v-card-text>
                <div style="background-color:#E0E0E0" class="pa-7 mt-3">
                    <div class="text-center">
                        <v-btn width="100%" large color="green"  class="ma-2" dark :loading="loading" @click="earnerCancelOrder()"> YES, CANCEL </v-btn>
                    </div>
                    <div class="text-center">
                        <v-btn color="red" large dark class="ma-2" width="100%" @click="cancelTrans=false">NO, CONTINUE</v-btn>
                    </div>
                    
                </div>
            </v-card>
            
           
        </v-dialog>

        <!-- timer try -->
        <v-row>
            <!-- <timer :time-left="timeLeft" /> -->
        </v-row>
        
    </v-container>
</template>
<script>
// import timer from '../components/timer'
export default {
    components:{
        // timer,
    },
    
    name:'ViewOrder',
    data(){
        return{
            timerInterval: null,
            snackbarVerify:false,
            timeLimit: 1800,
            timePassed: 0,
            snackbar:false,
            loading:false,
            dialog:false,
            dialog1: false,
            sendMsg:'',
            message:'',
            color:'',
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
            userId:this.$store.state.auth.logindetails.id,
            receiver:'',
            receiverId:'',
            cancelTrans:false,
            reason:'',
            reasonSub:'',
            rate:'0',
            readonly:false,
            loadmodify:false,
            reasons:['Additional Shipping or Fee/Tax', 'Item Out of Stock', 'Too Long Shipping Time', "Can't Ship to this Address", 'Accidentally Accepted', 'Other']
        }
    },
    computed:{
        order(){
            let order= this.$store.state.order.OrderById.offer[0]
            
            if (order.orderDate===null || order.orderDate===''){
                return order
                // console.log(order[j].orderDate)
            }else{
                order.orderDate= order.orderDate.slice(0, 19).replace('T', ' ');
                return order
            }
        },
        orderItems(){
            let order= this.$store.state.order.OrderById.offerItems
            
            return order
        },
        BtcRate(){
            return this.$store.state.offer.BtcRate
        },
        user(){
            return this.$store.state.auth.logindetails
        },
        messageCount(){
            return this.$store.state.order.OrderById.messageCount
        },
        messages(){
            return this.$store.state.order.OrderById.messages
        },
        timeLeft() {
            return this.timeLimit - this.timePassed
        },
        
        
    },
    methods:{
        shopperCancelOrder(){
            this.loading= true
            this.$store.dispatch("ShopperCancelOrder", this.$store.state.order.OrderById.offer[0].id)
            .then((success)=>{
                console.log(success)
                this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)
                this.color = 'green'
                this.message = 'Order Cancelled'
                this.snackbar = true
                this.loading = false
                this.dialog= true
            })
            .catch((error)=>{
                console.log(error.response)
                this.color = 'red'
                this.message = error.response.data.message
                this.loading=false
                this.snackbar = true
            })
        },
        earnerCancelOrder(){
            
            if(this.reason==='Other'){
                this.reason= this.reasonSub
            }
            this.loading= true
            this.$store.dispatch("EarnerCancelOrder", {
                'offerId':this.$store.state.order.OrderById.offer[0].id,
                'reason':this.reason
                })
            .then(()=>{
                this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)
                this.color = 'green'
                this.message = 'Offer Cancelled'
                this.snackbar = true
                this.loading = false
                this.dialog= true
            })
            .catch((error)=>{
                console.log(error.response)
                this.color = 'red'
                this.message = error.response.data.message
                this.loading=false
                this.snackbar = true
            })
        },
        confirmDelivery(){
            this.loading= true
            this.$store.dispatch("ConfirmDelivery", this.$store.state.order.OrderById.offer[0].id)
            .then((success)=>{
                console.log(success)
                this.$store.dispatch("GetOrderById",this.$store.state.order.OrderById.offer[0].id)
                this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)
                this.color = 'green'
                this.message = 'Order Confirmed'
                this.snackbar = true
                this.loading = false
                this.dialog1= true
            })
            .catch((error)=>{
                console.log(error.response)
                this.color = 'red'
                this.message = error.response.data.message
                this.loading=false
                this.snackbar = true
            })
        },
        updateRead(){
            if(this.messageCount>0){
               this.$store.dispatch("UpdateRead",this.order.id)
               .then((success)=>{
                   console.log(success)
                    this.$store.dispatch("GetOrderById",this.order.id)
                    this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)

                })
                .catch((error)=>{
                   console.log(error)
                })
            }
        },
        sendMessage(){
            this.loading=true
            if(this.userId===this.order.shopperId){
                this.receiver = this.order.earnerId
            }else{
                this.receiver = this.order.shopperId
            }
            this.$store.dispatch("SendMessage",
            {
                "text":this.sendMsg, 
                "status":this.order.status, 
                "wishlistTableId":this.order.id,
                "senderId":this.userId,
                "receiverId":this.receiver
            })
            .then((success)=>{
                console.log(success)
                this.$store.dispatch("GetOrderById",this.order.id)
                this.loading= false
                this.message= 'Message Sent!'
                this.color= 'green'
                this.snackbar = true
                this.sendMsg = ''
            })
            .catch((error)=>{
                console.log(error)
                this.message= 'Message not sent, Try again later!'
                this.color = 'red'
                this.snackbar = true
                this.loading = false
            })
        },
        startTimer() {
            this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
        },
        modify(){
                this.loadmodify=true
                this.$store.dispatch("GetOfferById", this.$store.state.order.OrderById.offer[0].id)
                .then((success)=>{
                    this.loadmodify=false
                    console.log(success);
                    this.$router.push('/modifyorder')
                })
                .catch((error)=>{
                    this.loadmodify=false
                    console.log(error);
                });
                
            
        },
        rating(value){
            this.readonly = true
            if(this.userId===this.order.shopperId){
                this.receiverId = this.order.earnerId
            }else{
                this.receiverId = this.order.shopperId
            }
            this.$store.dispatch("Rate",{
                "rating": value,
                "receiverId": this.receiverId
            })
            .then((success)=>{
                console.log(success)
                this.readonly = true
                this.$store.dispatch("GetOrderById",this.order.id)
                this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)
                this.message= "Rating Successful!"
                this.color = 'green'
                this.snackbar = true
            })
            .catch((error)=>{
                this.message = "Rating Unsuccessful"
                this.color = 'red'
                this.snackbar = true
                this.readonly = false
                console.log(error)
            })
        },
        
    },
    created(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }
        // gET BTC RATE
        this.$store.dispatch("GetBtcRate")
        .then(()=>{
            
        })
        .catch((error)=>{
            console.log(error);
        })
    },
    // watch:{
    //     start: function(){
    //             this.startTimer()
    //     }
    // }
    mounted() {
        this.startTimer();
    },
    
    
}
</script>
